import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { NgbCarouselConfig, NgbSlideEvent, NgbCarousel, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { CompletedFormModel } from 'src/app/models/completedForm.model';
import { CompletedFieldModel } from 'src/app/models/completedField.model';
import { Guid } from 'guid-typescript';
import { UploaderSettingModel } from 'src/app/models/uploaderSetting.model';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileServerService } from 'src/app/services/file-server.service';
import { FileUploaderComponent } from 'src/app/shared/components/file-uploader/file-uploader.component';
import { FileServerModel } from 'src/app/models/file-server.model';
import { FormFieldTypes } from 'src/app/shared/enumerators/form-field-types.enum';
import { NgClass, DatePipe } from '@angular/common';
import { ImagesCarouselComponent } from '../../../shared/images-carousel/images-carousel.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-schedule-completion-form',
  templateUrl: './schedule-completion-form.component.html',
  styleUrls: ['./schedule-completion-form.component.scss'],
  providers: [NgbCarouselConfig],
  imports: [NgbCarousel, NgbSlide, NgClass, ImagesCarouselComponent, MatIcon, FormsModule, ReactiveFormsModule, FileUploaderComponent, DatePipe]
})
export class ScheduleCompletionFormComponent implements OnInit {
  config = inject(NgbCarouselConfig);
  fileServerSrv = inject(FileServerService);

  @Input() completionFroms: CompletedFormModel[] = [];
  @Input() taskId: string = Guid.EMPTY;
  @Input() clientdata: any;

  @Output() reloadImgsFromTaskEvent = new EventEmitter<any>();

  totalPages: number = 0;
  pageIndicatorText: string = '';
  uploadersetting!: UploaderSettingModel;
  imageUploadreForm = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    name: new UntypedFormControl(null),
  });
  @ViewChild(FileUploaderComponent)
  fileUploaderComponent!: FileUploaderComponent;
  fileModel?: FileServerModel;
  fileUploader: boolean = false;
  loader: boolean = false;

  selectedMediaGroup: string = 'Todas';

  constructor() {
    const config = this.config;

    config.interval = 0;
    config.keyboard = false;
    config.showNavigationIndicators = false;
  }

  ngOnInit(): void {
    this.imageUploadreForm.controls.id.setValue(this.completionFroms[0].id);
    this.totalPages = this.completionFroms.length;
    this.uploadersetting = {
      accept: ['image/png', 'image/jpg', 'image/jpeg', 'image/webp', 'video/mp4'],
      inputWhith: '100%',
      imgWhith: '324px',
      imgHeight: '188px',
      controller: 'CompletionForms',
      formGroup: this.imageUploadreForm,
      validationsHeight: 188,
      validationsWhith: 324,
      validationMbMaxSize: 20,
      hideDelete: false,
      multiple: true,
    };

    this.completionFroms.sort(
      (a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime()
    );

    this.config.showNavigationArrows = this.completionFroms.length > 1;
    this.pageIndicatorText = `Pagina 1 de ${this.totalPages == 0 ? 1 : this.totalPages
      }`;
  }

  showFileUploader() {
    this.fileUploader = !this.fileUploader;
  }

  loadFile(event: any) {
    this.fileModel = event;
  }

  submitFile() {
    if (this.fileModel) {
      this.loader = true;
      this.fileModel.group = this.selectedMediaGroup === 'Todas'
        ? 'ReportImages'
        : this.selectedMediaGroup;

      this.fileUploaderComponent.saveFile(this.fileModel).subscribe({
        next: () => {
          this.reloadImgsFromTaskEvent.emit();
          this.ngOnInit();
        },
        error: (err) => {
          console.error('Error al guardar el archivo ', err);
          this.loader = false;
        },
        complete: () => {
          this.loader = false;
        },
      });
    }
  }

  compareConditions(compareWithField: any, condition: string[]) {
    if (!condition || condition.length !== 2) {
      console.error('Invalid condition format:', condition);
      return false;
    }

    const [operatorComparer, valueToCompare] = condition;

    if (compareWithField === null || compareWithField === undefined) {
      console.warn('compareConditions called with null field value');
      return false;
    }

    try {
      const fieldValue = compareWithField.toString();

      switch (operatorComparer) {
        case '=':
        case '==': return fieldValue == valueToCompare;
        case '!=':
        case '!==': return fieldValue != valueToCompare;
        default:
          console.error(`Invalid operator: ${operatorComparer}`);
          return false;
      }
    } catch (error) {
      console.error('Error comparing conditions', error, { operatorComparer, compareWithField, valueToCompare });
      return false;
    }
  }

  _getVisibleConditions(fields: any[], field: CompletedFieldModel): boolean {
    if (!field) return true;
    let visible = true;

    // AutoHide condition
    if (field.autoHide && Array.isArray(field.values) && field.values.length === 1) {
      visible = !this.compareConditions(field.values[0], field.autoHideValues!);
    }

    // Conditional visibility based on parent field
    if (visible && field.parentId) {
      const compareWithField = fields.find(f => f.id === field.parentId);

      if (!compareWithField || !Array.isArray(compareWithField.values) || compareWithField.values.length === 0) {
        console.warn('Parent field invalid or has no values', { field, compareWithField });
        return visible;
      }

      visible = this.compareConditions(
        compareWithField.values[0],
        field.conditionValues!
      );

      // Recursive parent visibility check
      if (visible && compareWithField.parentId)
        visible = this._getVisibleConditions(fields, compareWithField);
    }

    return visible;
  }

  drawDynamicReportContent(fields: any[], index: number) {
    let field = fields[index];

    if (!field.values || field.values.length === 0 || !field.values[0]) {
      return '';
    }

    if (!this._getVisibleConditions(fields, field)) {
      return '';
    }

    switch (field.type.toString()) {
      case FormFieldTypes.Search.toString():
        let result = '<ul>';

        field.values.forEach((element: any) => {
          const el = JSON.parse(element);
          result += `<li><b>x${el.value}</b>  ${el.name}</li>`;
        });

        result += '</ul>';
        return result;

      case FormFieldTypes.OneValue.toString():
        return `<span>${field.name}  (${field.labels[0]
          }) <b>${this.getDynamicValue(field.values[0])}</b></span>`;

      case FormFieldTypes.TwoValues.toString():
        return `<span>${field.name}:  (${field.labels[0]
          }) <b>${this.getDynamicValue(field.values[0])}</b>  -  (${field.labels[1]
          }) <b>${field.values[1]}</b></span>`;

      case FormFieldTypes.YesNo.toString():
        return `<span>${field.name}  <b>${this.getDynamicValue(
          field.values[0]
        )}</b></span>`;

      case FormFieldTypes.Options.toString():
        let val = `<table><tr><td class="align-top" rowspan="${field.values.length}"><span>${field.name}:</span></td>`;

        for (let i = 0; i < field.values.length; i++) {
          val += `${field.labels && field.labels[i]
            ? '<td>(' + field.labels[i] + ') </td>'
            : '<td></td>'
            }
                      ${field.values && field.values[i]
              ? `<td><b>${this.getDynamicValue(
                field.values[i]
              )}</b></td></tr>`
              : '<td></td></tr>'
            }</span>`;
        }
        return ` ${val}</table>`;

      case FormFieldTypes.FreeText.toString():
        return field.values.length > 0
          ? `<span>${this.getDynamicValue(field.values[0])}</span>`
          : ``;

      case FormFieldTypes.Legend.toString():
        return `<span><b>${field.name}</b></span>`;

      case FormFieldTypes.Rating.toString():
        if (!field.values || !field.values.length) return '';

        // Inicialize
        let rawValue = this.getDynamicValue(field.values[0]);
        let starRating = Number.parseFloat(rawValue);
        let starRatingArr = [];

        // Check if it contains half a star.
        let isHalf = starRating % 1 !== 0 ? true : false;

        for (let i = 0; i < starRating; i++) {
          starRatingArr.push(i);
        }

        // Build the html.
        let ratingHtml = '';

        ratingHtml += `<span>${field.name}</span></br>`;
        ratingHtml += `<div class="wrapper">`;

        // Draw empty stars.
        ratingHtml += '<div class="item">';
        for (let i = 0; i < 5; i++) {
          ratingHtml += '<div class="fav fav-star-default"></div>';
        }
        ratingHtml += '</div>';

        // Fill stars.
        ratingHtml += '<div class="item">';
        for (let i = 0; i < starRatingArr.length; i++) {
          ratingHtml += '<div class="fav fav-star is-animating"></div>';
        }
        if (isHalf) {
          ratingHtml +=
            '<div class="halfstar1">&#x2605;</div><div class="halfstar2">&#x2605;</div>';
        }
        ratingHtml += '</div>';

        ratingHtml += '</div>';

        return ratingHtml;

      case FormFieldTypes.DynamicKeyValue.toString():
        let returnHtml = '<ul>';

        field.values.forEach((element: any) => {
          const el = JSON.parse(element);
          returnHtml += `<li><span>${el.name
            }: </span><b>${this.getDynamicValue(
              el.value
            )} ${this.getDynamicValue(field.labels[0])}</b></li>`;
        });

        returnHtml += '</ul>';
        return returnHtml;

      case FormFieldTypes.Images.toString(): //Images are all together in a separated item
        return '';

      case FormFieldTypes.RadioButton.toString():
        return `<span>${field.values[0]}</span>`;

      case FormFieldTypes.CheckBoxList.toString():
        let returnList = '<ul>';

        field.values.forEach((element: any) => {
          const el = JSON.parse(element);
          returnList += `<li><span>${el.name}: </span><b>${this.getDynamicValue(el.value)}</b></li>`;
        });

        returnList += '</ul>';
        return returnList;

      default:
        return `<span>${field?.labels[index]
          ? '(' + field.labels[index] + ') '
          : ''
          }${field.values[index]}</span>`;
    }
  }

  getDynamicValue(value: any): string {
    switch (String(value)) {
      case 'true':
        return 'SI';
      case 'false':
        return 'NO';
      case '':
        return '-';
      default:
        return value;
    }
  }

  openImage(url: any) {
    window.open(url, '_blank');
  }

  onSlide(slideEvent: NgbSlideEvent) {
    let current = Number.parseInt(slideEvent.current) + 1;
    this.pageIndicatorText = `Pagina ${current} de ${this.totalPages}`;
  }

  getFilesForField(allFiles: any[], fieldValues: any): any[] {
    if (!fieldValues || !allFiles) return [];

    try {
      // Si fieldValues es un string (como viene del BE), lo parseamos
      const valuesArray = typeof fieldValues === 'string' ? JSON.parse(fieldValues) : fieldValues;
      const groupName = valuesArray[0];

      if (!groupName) return [];

      // Filtramos los archivos cuyo atributo 'group' coincida con el valor del campo
      return allFiles.filter(file => file.group === groupName);
    } catch (error) {
      console.error("Error al parsear el grupo de imágenes:", error);
      return [];
    }
  }

  // Función auxiliar para extraer el ID del grupo de forma segura
  private getSafeGroupId(field: any): string {
    if (!field || !field.values) return '';

    // Si values es un string (como viene del BE), lo tratamos de procesar
    // Si ya es un array (por el modelo), tomamos el primer índice
    const rawValue = Array.isArray(field.values) ? field.values[0] : field.values;

    try {
      // Intentamos parsear solo si parece JSON (contiene comillas o corchetes)
      if (typeof rawValue === 'string' && (rawValue.includes('"') || rawValue.includes('['))) {
        const parsed = JSON.parse(rawValue);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      }
      return rawValue;
    } catch (e) {
      return rawValue;
    }
  }

  getAvailableMediaGroups(form: any): { id: string, name: string }[] {
    if (!form.files || !form.groups) return [];

    const groupsWithMedia: { id: string, name: string }[] = [];

    form.groups.forEach((group: any) => {
      const imageField = group.fields.find((f: any) => f.type.toString() === '10');

      if (imageField) {
        const groupId = this.getSafeGroupId(imageField);

        // Verificamos si hay archivos para este ID
        const hasFiles = form.files.some((file: any) => file.group === groupId);

        if (hasFiles) {
          groupsWithMedia.push({
            id: groupId,
            name: group.name
          });
        }
      }
    });

    return groupsWithMedia;
  }

  getFilteredFiles(files: any[]): any[] {
    if (this.selectedMediaGroup === 'Todas') return files;
    return files.filter(file => file.group === this.selectedMediaGroup);
  }

  hasVisibleFields(group: any): boolean {
    return group.fields.some((f: any) => f.type.toString() !== '10');
  }
}
